import React, { memo } from "react";

import SvgIcon from "@mui/material/SvgIcon";

export const MapIcon = memo((props) => {
  return (
    <SvgIcon
      viewBox="0 0 422.932 422.932"
      {...props}
      transform="translate(0, -1) scale(0.8, 0.8)"
    >
      <path
        style={{ fill: "none" }}
        d="M160.986,108.586c-3.877,6.396-41.223,54.328-41.795,54.953c-2.273,2.482-5.484,3.896-8.85,3.896
		c-3.367,0-6.578-1.414-8.85-3.896c-0.572-0.625-37.92-48.557-41.797-54.953H35.92v181.195l181.195-181.195H160.986z"
      />
      <polygon
        style={{ fill: "none" }}
        points="52.891,398.932 276.276,398.932 164.584,287.24 	"
      />
      <path
        style={{ fill: "none" }}
        d="M202.432,232.902c-7.434-8.053-1.971-15.576-0.238-17.189
		c-0.006-0.002,107.104-107.127,107.104-107.127h-58.24L35.92,323.723v58.238L156.1,261.783c4.686-4.686,12.283-4.686,16.971,0
		l137.146,137.148h58.238L202.429,232.906C202.43,232.904,202.431,232.902,202.432,232.902z"
      />
      <path
        style={{ fill: "none" }}
        d="M296.389,155.434l60.26,60.26c4.688,4.688,4.688,12.285,0,16.971l-60.26,60.262l90.633,90.631V108.586
		h-43.783L296.389,155.434z"
      />
      <path
        style={{ fill: "none" }}
        d="M152.584,66.244c0-23.293-18.949-42.244-42.242-42.244C87.049,24,68.1,42.951,68.1,66.244
		c0,15.094,22.445,47.521,42.242,70.992C130.139,113.766,152.584,81.338,152.584,66.244z"
      />

      <rect
        x="242.809"
        y="187.569"
        transform="matrix(0.7071 0.7071 -0.7071 0.7071 240.3658 -131.9192)"
        style={{ fill: "none" }}
        width="73.22"
        height="73.221"
      />

      <line
        style={{
          fill: "none",
          stroke: "black",
          strokeWidth: 0,
          strokeLinecap: "round",
          strokeLinejoin: "round",
        }}
        x1="23.559"
        y1="422.932"
        x2="23.555"
        y2="422.932"
      />
      <path
        style={{ fill: "black" }}
        d="M399.022,84.586H172.899c2.461-6.824,3.686-12.924,3.686-18.342C176.584,29.717,146.867,0,110.342,0
		C73.815,0,44.1,29.717,44.1,66.244c0,5.418,1.225,11.518,3.686,18.342H23.92c-6.627,0-12,5.373-12,12v313.689
		c0,0-0.791,12.045,11.639,12.656c0.684,0,375.463,0,375.463,0c6.629,0,12-5.373,12-12V96.586
		C411.022,89.959,405.651,84.586,399.022,84.586z M110.342,24c23.293,0,42.242,18.951,42.242,42.244
		c0,15.094-22.445,47.521-42.242,70.992C90.545,113.766,68.1,81.338,68.1,66.244C68.1,42.951,87.049,24,110.342,24z M35.92,108.586
		h23.775c3.877,6.396,41.225,54.328,41.797,54.953c2.271,2.482,5.482,3.896,8.85,3.896c3.365,0,6.576-1.414,8.85-3.896
		c0.572-0.625,37.918-48.557,41.795-54.953h56.129L35.92,289.781V108.586z M52.891,398.932L164.584,287.24l111.691,111.691H52.891z
		 M310.217,398.932L173.07,261.783c-4.688-4.686-12.285-4.686-16.971,0L35.92,381.961v-58.238l215.137-215.137h58.24
		c0,0-107.109,107.125-107.104,107.127c-1.732,1.613-7.195,9.137,0.238,17.189c-0.001,0-0.002,0.002-0.003,0.004l166.026,166.025
		H310.217z M279.42,172.404l51.773,51.775l-51.773,51.773l-51.775-51.773L279.42,172.404z M387.022,383.557l-90.633-90.631
		l60.26-60.262c4.688-4.686,4.688-12.283,0-16.971l-60.26-60.26l46.85-46.848h43.783V383.557z"
      />
    </SvgIcon>
  );
});
